import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getTopFiveAddonsData = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_TOP_FIVE_ADDON_SALES,
    payload: paramObj,
    meta: {
        type: 'apijson',
        url: baseUrl + '/top_five_item_addon_sales',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond,
            database: paramObj.type
        },
        options: {
            method: 'GET'
        }
    }
})